export default function Footer() {
  return (
    <footer className="w-full py-8 bg-[#12141e]">
      <div className="max-w-5xl mx-auto px-8 text-center">
        <p className="text-sm text-white/40 italic">
          Copyright (c) 2016-2026 - Mastro Minds, LLC
        </p>
      </div>
    </footer>
  );
}
